import PropTypes from 'prop-types';
import React from 'react';
import { optionsPropTypes } from './SelectPropTypes';
import { DEFAULT_SELECT_PLACEHOLDER } from '../../../../config/constants';
import { clearRegions, getRegions } from '../../../../actions';
import Select from './Select';
import { useLayoutEffect } from 'react';
import { connect } from 'react-redux';

export const RegionSelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchGetRegions,
  dispatchClearRegions,
  placeholder,
  ...rest
}) => {
    useLayoutEffect(() => () => dispatchClearRegions(), []); 

    const handleInputChange = (inputValue) => {
      if (inputValue.trim().length && inputValue.trim().length >= 2) {
        dispatchGetRegions({ query: inputValue });
      }
    };

    return (
    <Select
        isLoading={loading}
        onInputChange={handleInputChange}
        options={options}
        isMulti={isMulti}
        onValueChange={onValueChange}
        isClearable={isClearable}
        isGridVariant={isGridVariant}
        placeholder={placeholder}
        {...rest}
    />
    );
}

RegionSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  options: optionsPropTypes.isRequired,
  loading: PropTypes.bool.isRequired,
  noOptionsMessage: PropTypes.func,
  dispatchGetRegions: PropTypes.func.isRequired,
  dispatchClearRegions: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  onValueChange: PropTypes.func,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
};

RegionSelect.defaultProps = {
  noOptionsMessage: undefined,
  isDisabled: false,
  isGridVariant: false,
  onValueChange: undefined,
  isClearable: false,
  value: {},
  isMulti: false,
  placeholder: DEFAULT_SELECT_PLACEHOLDER,
};

const mapStateToProps = ({ LocationUnit }) => ({
  options: LocationUnit.Region.getIn(['all', 'content', 'content']).map(
    (region) => ({
    value: region.id,
    label: `${region.name}, ${region.country.name}`,
  }),),
  loading: LocationUnit.Region.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetRegions: getRegions,
  dispatchClearRegions: clearRegions,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegionSelect);
